import styled from 'styled-components/macro';
import CsvFilter from './CsvFilter';
import { marginTableMobile } from '../styles/utils';

export const FilterWrapperContainerDiv = styled.div`
  @media screen and (max-width: 767px) {
    height: 182px;
  }
`;

export const FilterWrapperDiv = styled.div`
  @media screen and (max-width: 767px) {
    background-color: ${props => props.theme.concrete};
    height: 150px;
    /* padding-left: 36px;
    padding-right: 36px; */
    padding-top: 40px;
    ${props => props.theme.bottomDropShadow};
    position: absolute;
    width: 100%;
    left: 0;
    padding-left: ${marginTableMobile};
    padding-right: ${marginTableMobile};
  }
`;

export const FilterWrapperContentDiv = styled.div`
  @media screen and (max-width: 767px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const CustomCsvFilter = styled(CsvFilter)`
  flex-grow: unset;
`;
